import {
  Box,
  Button,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  TextInput,
  Title,
  Text,
  Badge,
  Tooltip,
  ActionIcon,
} from "@mantine/core";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import { IconEdit, IconPlus, IconSearch, IconTrash } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useDeferredValue, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { getTblDmEmployeeAll } from "../../../service/getSelectApi";
import { getValueById } from "../../../_base/helper/FunctionHelper";
import { modals } from "@mantine/modals";
import CreateDataView from "./CreateDataView";
import EditDataView from "./EditDataView";
import DeleteDataView from "./DeleteDataView";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const TemProduct = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState<any>({});
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );

  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      { accessorKey: "maHang", header: "Mã loại" },
      { accessorKey: "tenHang", header: "Tên loại" },
      {
        accessorKey: "temHacom",
        header: "Tem HACOM",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge
              variant="gradient"
              gradient={{ from: "#EA242A", to: "#2B3276", deg: 90 }}
            >
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "temDvt",
        header: "Tem dịch vụ tốt",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge color="#F7262B">{renderedCellValue}</Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "createdDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "createdBy",
        header: "Người tạo",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(String(renderedCellValue), dataEmployee, "label")}
          </Text>
        ),
      },
      {
        accessorKey: "lastUpdatedDate",
        header: "Ngày cập nhật gần nhất",
        size: 225,
        Cell: ({ renderedCellValue }: any) => (
          <Text size="12.5px" fw={"500"}>
            {renderedCellValue && formatDateTransfer(renderedCellValue)}
          </Text>
        ),
      },
      {
        accessorKey: "lastUpdatedBy",
        header: "Người cập nhật gần nhất",
        size: 225,
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(String(renderedCellValue), dataEmployee, "label")}
          </Text>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableColumnFilter: false,
        enableSorting: false,
        size: 85,
        Cell: ({ row }) => (
          <Flex gap={"sm"} align={"center"}>
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                color="orange"
                variant="light"
                onClick={() => modalEditTemProduct(row.original)}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                color="red"
                variant="light"
                onClick={() => modalDeleteTemProduct([row.original.id])}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [dataEmployee]
  );

  const modalCreateTemProduct = () => {
    modals.openConfirmModal({
      title: <Title order={5}>Tạo mới Tem sản phẩm !</Title>,
      size: "auto",
      children: <CreateDataView onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const modalEditTemProduct = (dataEdit: any) => {
    modals.openConfirmModal({
      title: <Title order={5}>Chỉnh sửa Tem sản phẩm !</Title>,
      size: "auto",
      children: <EditDataView dataEdit={dataEdit} onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const modalDeleteTemProduct = (listId: number[]) => {
    modals.openConfirmModal({
      title: <Title order={5}>Xóa Tem sản phẩm !</Title>,
      size: "auto",
      children: <DeleteDataView listId={listId} onSuccess={fetchData} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/TblTemItem/get-list?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
        table.resetRowSelection();
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
        })
      );
    }
  };

  // const exportDataExcel = async () => {
  //   open();
  //   try {
  //     let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

  //     const params = new URLSearchParams();
  //     Object.entries(search).forEach(([key, value]) => {
  //       if (Array.isArray(value) && value.length > 0) {
  //         value.forEach((item) => params.append(key, String(item)));
  //       } else if (typeof value === "string" && value.length > 0) {
  //         params.append(key, value);
  //       }
  //     });

  //     if (keySearch.length > 0) {
  //       url += `&KeySearch=${keySearch?.trim()}`;
  //     }

  //     url += `&${params.toString()}`;

  //     const baseUrl = `/api/v1/ItemComparison/export-excel${url}`;

  //     const _url = BASE_API_MDM + baseUrl;
  //     const token = localStorage.getItem("token");

  //     const response = await fetch(_url, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/vnd.ms-excel",
  //         Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
  //       },
  //     });

  //     if (!response.ok) {
  //       NotificationExtension.Fails("Export Excel thất bại !");
  //     } else {
  //       const blob = await response.blob();
  //       const urlss = window.URL.createObjectURL(blob);
  //       const _name = new Date().toISOString().slice(0, 10);
  //       let filename = "danh_sach_voucher.xlsx";
  //       const link = document.createElement("a");
  //       link.href = urlss;
  //       link.download = filename;
  //       document.body.appendChild(link);
  //       link.click();
  //       link.remove();
  //       window.URL.revokeObjectURL(url);
  //       NotificationExtension.Success("Export Excel thành công !");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     close();
  //   }
  // };

  const getDataEmp = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      const data = res
        .filter((item) => item.id && item.fullname)
        .map((item) => ({
          label: `${item.code} - ${item.fullname}`,
          value: String(item.id),
        }));
      setDataEmployee(data);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    getDataEmp();
  }, []);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningTemProduct"
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "mrt-row-numbers"],
          right: ["action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage()
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningTemProduct",
      JSON.stringify(columnPinning)
    );
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"md"}>
            <Button
              leftSection={<IconTrash size={14} />}
              color="red"
              onClick={() =>
                modalDeleteTemProduct(selectIds.map((item) => Number(item)))
              }
              disabled={selectIds.length === 0}
            >
              Xóa
            </Button>
            <Button
              leftSection={<IconPlus size={14} />}
              color="teal"
              onClick={() => modalCreateTemProduct()}
            >
              Tạo mới
            </Button>
            {/* <Button
              leftSection={<IconFileTypeCsv size={16} />}
              onClick={() => exportDataExcel()}
            >
              Export Excel
            </Button> */}
          </Flex>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default TemProduct;
